/* global axios */

import ApiClient from './ApiClient';

class AuditLogs extends ApiClient {
  constructor() {
    super('audit_logs', { accountScoped: true });
  }

  get({ page, conversationId, agentId, botId, startDate, endDate } = {}) {
    const params = new URLSearchParams();
    if (page) params.append('page', page);
    if (conversationId) params.append('conversation_id', conversationId);
    if (agentId) params.append('agent_id', agentId);
    if (botId) params.append('bot_id', botId);
    if (startDate) params.append('start_date', startDate);
    if (endDate) params.append('end_date', endDate);

    const query = params.toString();
    const url = query ? `${this.url}?${query}` : this.url;
    return axios.get(url);
  }
}

export default new AuditLogs();
